module.exports = __webpack_public_path__ + "img/house_03.93766158.jpg";